// Translation for el
export const el = {
        common: {
            save: 'Αποθήκευση',
            cancel: 'Ακύρωση',
            close: 'Κλείσιμο',
            delete: 'Διaγραφή',
            edit: 'Επεξεργασία',
            activate: 'Ενεργοποίηση',
            add: 'Προσθήκη',
            saving: 'Αποθήκευση...',
            loading: 'Φόρτωση...',
            active: 'ΕΝΕΡΓΟ',
            inUse: 'Σε Χρήση',
            test: 'Δοκιμή',
            searchApps: 'Αναζήτηση εφαρμογών...',
            betaBanner: 'BETA - Η υπηρεσία δεν είναι διαθέσιμη ακόμα!'
        },
        header: {
            creditBalance: 'Υπόλοιπο',
            minutes: 'ΛΕΠ'
        },
        auth: {
            signIn: 'Σύνδεση',
            signUp: 'Εγγραφή',
            username: 'Όνομα χρήστη',
            password: 'Κωδικός',
            continue: 'Συνέχεια',
            noAccount: 'Δεν έχεις λογαριασμό;',
            hasAccount: 'Έχεις ήδη λογαριασμό;',
            loginError: 'Η σύνδεση απέτυχε',
            invalidCredentials: 'Μη έγκυρο όνομα χρήστη ή κωδικός',
            rateLimited: 'Πολλές προσπάθειες σύνδεσης. Περίμενε λίγο.',
            sessionExpired: 'Η συνεδρία σου έληξε. Χρησιμοποίησε ένα νέο μαγικό σύνδεσμο.',
            magicLinkInvalid: 'Ο σύνδεσμος σύνδεσης είναι μη έγκυρος ή έχει λήξει.',
            magicLinkSuccess: 'Καλώς ήρθες! Συνδέθηκες με επιτυχία.',
            magicLinkProcessing: 'Επεξεργασία σύνδεσης...',
            connectionError: 'Σφάλμα σύνδεσης. Προσπάθησε ξανά.'
        },
        profile: {
            myProgress: 'Η Πρόοδός μου στη Μάθηση',
            signOut: 'Αποσύνδεση',
            plan: 'Σχέδιο: '
        },
        settings: {
            title: 'Ρυθμίσεις',
            tabs: {
                uiSettings: 'Ρυθμίσεις UI',
                systemPrompt: 'Σύστημα Προτροπής',
                llmProfiles: 'Προφίλ LLM',
                ttsProfiles: 'Προφίλ TTS',
                language: 'Γλώσσα',
            },
            uiSettings: {
                title: 'Διεπαφή Χρήστη',
                themeMode: 'Λειτουργία Θέματος',
                darkMode: 'Σκοτεινή Λειτουργία',
                lightMode: 'Ανοιχτή Λειτουργία',
                themeColor: 'Χρώμα Θέματος',
                themeColorDesc: 'Επίλεξε το χρώμα έμφασης για κουμπιά, εικονίδια και επισημάνσεις',
                background: 'Φόντο',
                backgroundDesc: 'Επίλεξε ένα φόντο για τον χώρο εργασίας σου',
                selectBackgroundColor: 'Επίλεξε Χρώμα Φόντου',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Εστίαση',
                    concentration: 'Συγκέντρωση',
                    relaxation: 'Χαλάρωση',
                    lianas: 'Κλήματα',
                    color: 'Χρώμα'
                },
                backgroundColors: {
                    deepDark: 'Βαθύ Μαύρο',
                    darkGrey: 'Σκούρο Γκρι',
                    midnightBlue: 'Μεσονύχτιο Μπλε',
                    indigo: 'Ίντιγκο',
                    darkTeal: 'Σκούρο Κυανό',
                    brown: 'Καφέ',
                    darkRed: 'Σκούρο Κόκκινο',
                    deepPurple: 'Βαθύ Ιώδες',
                    pureWhite: 'Καθαρό Λευκό',
                    softWhite: 'Απαλό Λευκό',
                    lightGrey: 'Ανοιχτό Γκρι',
                    paleBlue: 'Χλωμό Μπλε',
                    paleGreen: 'Χλωμό Πράσινο',
                    paleOrange: 'Χλωμό Πορτοκαλί',
                    lavender: 'Λεβάντα',
                    blueGrey: 'Μπλε-Γκρι'
                }
            },
            systemPrompt: {
                label: 'Σύστημα Προτροπής:',
                placeholder: 'Φόρτωση συστήματος προτροπής...',
                emptyError: 'Η προτροπή του συστήματος δεν μπορεί να είναι κενή!',
                saveSuccess: '✓ Η προτροπή του συστήματος αποθηκεύτηκε με επιτυχία!',
                loadError: 'Σφάλμα φόρτωσης προτροπής του συστήματος',
                saveError: 'Σφάλμα αποθήκευσης'
            },
            llmProfiles: {
                addButton: '+ Προσθήκη Νέας Σύνδεσης',
                newConnection: 'Νέα Σύνδεση',
                editConnection: 'Επεξεργασία Σύνδεσης',
                emptyState: 'Δεν υπάρχουν διαθέσιμες συνδέσεις LLM. Κάνε κλικ παρακάτω για να προσθέσεις μία.',
                loadingProfiles: 'Φόρτωση προφίλ...',
                nameLabel: 'Όνομα *',
                namePlaceholder: 'π.χ. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Κλειδί API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Μοντέλο *',
                modelPlaceholder: 'gpt-4, mistral-tiny, κ.λπ.',
                allFieldsRequired: 'Όλα τα πεδία πρέπει να συμπληρωθούν!',
                saveSuccess: '✓ Το προφίλ αποθηκεύτηκε με επιτυχία!',
                deleteConfirm: 'Θέλεις πραγματικά να διαγράψεις το "{name}";',
                profileNotFound: 'Το προφίλ δεν βρέθηκε!',
                loadError: 'Σφάλμα φόρτωσης προφίλ',
                saveError: 'Σφάλμα αποθήκευσης',
                activateError: 'Σφάλμα ενεργοποίησης',
                deleteError: 'Σφάλμα διαγραφής',
                modelInfo: 'Μοντέλο: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Προσθήκη Νέας Φωνής',
                newVoice: 'Νέα Φωνή',
                editVoice: 'Επεξεργασία Φωνής',
                emptyState: 'Δεν υπάρχουν διαθέσιμα προφίλ TTS. Κάνε κλικ παρακάτω για να προσθέσεις ένα.',
                loadingProfiles: 'Φόρτωση προφίλ TTS...',
                nameLabel: 'Όνομα',
                namePlaceholder: 'π.χ. Ο Δικός μου ElevenLabs Adam',
                providerLabel: 'Πάροχος',
                providerPlaceholder: 'π.χ. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Τοπικό)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Κλειδί API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Μοντέλου *',
                modelIdPlaceholder: 'π.χ. eleven_monolingual_v1',
                voiceIdLabel: 'ID Φωνής',
                voiceIdPlaceholder: 'π.χ. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Όλα τα πεδία πρέπει να συμπληρωθούν!',
                saveSuccess: '✓ Το προφίλ TTS αποθηκεύτηκε με επιτυχία!',
                deleteConfirm: 'Θέλεις πραγματικά να διαγράψεις το "{name}";',
                loadError: 'Σφάλμα φόρτωσης προφίλ TTS',
                saveError: 'Σφάλμα αποθήκευσης',
                activateError: 'Σφάλμα ενεργοποίησης',
                deleteError: 'Σφάλμα διαγραφής'
            },
            language: {
                title: 'Επίλεξε Γλώσσα',
                description: 'Επίλεξε την προτιμώμενη γλώσσα για τη διεπαφή χρήστη'
            },
        },
        chat: {
            ready: 'Έτοιμο',
            start: 'ΕΝΑΡΞΗ',
            stop: 'ΔΙΑΚΟΠΗ',
            initialMessage: 'Κάνε κλικ ΕΝΑΡΞΗ για συνομιλία σε πραγματικό χρόνο.',
            listening: 'Ακούω...',
            speaking: 'Ο Thorsten μιλά...',
            userLabel: 'Εσύ',
            aiLabel: 'AI',
            modalTitle: 'Chat AI Thorsten',
            inputPlaceholder: 'Πληκτρολόγησε ένα μήνυμα...',
            send: 'Αποστολή',
            loginRequired: 'Συνδέσου για να χρησιμοποιήσεις αυτήν την υπηρεσία.',
            loginButton: 'Σύνδεση Τώρα',
            magicLinkRequired: 'Χρησιμοποίησε έναν μαγικό σύνδεσμο για σύνδεση.',
            creditLimitError: 'Η ωριαία σου ποσόστωση έχει εξαντληθεί. Αναβάθμισε το σχέδιό σου (Medium/Premium) για να συνεχίσεις.',
            serviceDisabled: 'Η υπηρεσία συνομιλίας δεν είναι διαθέσιμη αυτή τη στιγμή. Παρακαλώ δοκιμάστε ξανά αργότερα.'
        },
        notifications: {
            error: 'Σφάλμα',
            success: 'Επιτυχία',
            info: 'Πληροφορία',
            unknownError: 'Ένα άγνωστο σφάλμα προέκυψε'
        },
        cookie: {
            message: 'Αυτός ο ιστότοπος χρησιμοποιεί cookies για να σας παρέχει την καλύτερη δυνατή εμπειρία χρήστη.',
            accept: 'Δεχόμαι'
        },
        curriculum: {
                buttonLabel: 'Πρόγραμμα Σπουδών',
                buttonTitle: 'Εμφάνιση περιεχομένου προγράμματος σπουδών',
                modalTitle: 'Πρόγραμμα Σπουδών {app}',
                sections: {
                    topic: 'Θέμα προγράμματος σπουδών',
                    explanation: 'Επεξήγηση για παιδιά',
                    studentProfile: 'Προφίλ μαθητή'
                },
                topic: {
                    empty: 'Δεν υπάρχει θέμα προγράμματος σπουδών συνδεδεμένο με αυτή τη μικρο-εφαρμογή στο backend.',
                    missingDetail: 'Λεπτομερή δεδομένα προγράμματος σπουδών για αυτή τη μικρο-εφαρμογή δεν είναι ακόμα διαθέσιμα στο backend.',
                    learningGoals: 'Στόχοι μάθησης',
                    prerequisites: 'Προαπαιτούμενα',
                    unitLabel: 'Ενότητα',
                    durationLabel: 'Διάρκεια',
                    difficultyLabel: 'Δυσκολία',
                    hours: 'ώρ',
                    minutes: 'λεπ'
                },
                explanation: {
                    empty: 'Δεν υπάρχει διαθέσιμη επεξήγηση για παιδιά.',
                    loadingPrepare: 'Το AI προετοιμάζει την επεξήγηση',
                    loadingExplain: 'Το AI εξηγεί το θέμα σε γλώσσα κατάλληλη για παιδιά',
                    requestFailed: 'Δεν ήταν δυνατή η δημιουργία επεξήγησης για παιδιά.'
                },
                studentProfile: {
                    country: 'Χώρα',
                    region: 'Πολιτεία / Περιοχή',
                    schoolType: 'Τύπος σχολείου',
                    grade: 'Τάξη',
                    noContext: 'Δεν υπάρχει διαθέσιμο πλαίσιο μαθητή.',
                    childProfileNotFound: 'Δεν βρέθηκε προφίλ μαθητή στο backend για την τρέχουσα σύνδεση.',
                    loginProfileIncomplete: 'Το προφίλ σύνδεσης δεν περιέχει ακόμα πλήρες πλαίσιο μαθητή.',
                    educationContextNotFound: 'Βρέθηκε προφίλ μαθητή, αλλά δεν έχει οριστεί ανάθεση προγράμματος σπουδών.',
                    noToken: 'Δεν βρέθηκε συνδεδεμένος μαθητής.'
                },
                errors: {
                    signInRequired: 'Παρακαλώ συνδεθείτε για να δείτε το πρόγραμμα σπουδών.',
                    appIdMissing: 'Λείπει το αναγνωριστικό εφαρμογής.',
                    loadFailed: 'Αδυναμία φόρτωσης δεδομένων προγράμματος σπουδών.'
                }
            }
    };
